module.exports = __webpack_public_path__ + "img/temperature.bf0334d5.png";